// extracted by mini-css-extract-plugin
export default {"accessRightIndicator":"teamCard_accessRightIndicator__+Qsfe"};